import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/analytics"

export default class extends Controller {
  static targets = [
    "form", "success",
    "firstName", "lastName", "email", "phone", "message",
    "error", "errorText",
    "submitButton", "submitText", "loadingSpinner"
  ]

  async submit(event) {
    event.preventDefault()
    this.hideError()

    // Validation
    if (!this.firstNameTarget.value.trim() || !this.lastNameTarget.value.trim() ||
        !this.emailTarget.value.trim() || !this.messageTarget.value.trim()) {
      this.showError("Veuillez remplir tous les champs obligatoires")
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(this.emailTarget.value)) {
      this.showError("Veuillez entrer une adresse email valide")
      return
    }

    if (this.messageTarget.value.length < 10) {
      this.showError("Le message doit contenir au moins 10 caracteres")
      return
    }

    this.setLoading(true)

    try {
      const response = await fetch("/api/contacts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        body: JSON.stringify({
          firstName: this.firstNameTarget.value,
          lastName: this.lastNameTarget.value,
          email: this.emailTarget.value,
          phone: this.phoneTarget.value,
          message: this.messageTarget.value
        })
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l'envoi")
      }

      // Show success
      track("contact-envoye")
      this.formTarget.classList.add("hidden")
      this.successTarget.classList.remove("hidden")

    } catch (error) {
      console.error("Contact form error:", error)
      this.showError(error.message || "Erreur lors de l'envoi du message")
    } finally {
      this.setLoading(false)
    }
  }

  back() {
    // Go back to contact choice
    const contactFormController = this.element.closest("[data-controller~='contact-form']")
    if (contactFormController) {
      contactFormController.querySelector("[data-contact-form-target='choice']").classList.remove("hidden")
      contactFormController.querySelector("[data-contact-form-target='contact']").classList.add("hidden")
    }
  }

  close() {
    // Reset form and go back to choice
    this.formTarget.reset()
    this.formTarget.classList.remove("hidden")
    this.successTarget.classList.add("hidden")
    this.back()
  }

  showError(message) {
    if (this.hasErrorTarget && this.hasErrorTextTarget) {
      this.errorTextTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
    }
  }

  setLoading(loading) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = loading
    }
    if (this.hasLoadingSpinnerTarget) {
      if (loading) {
        this.loadingSpinnerTarget.classList.remove("hidden")
      } else {
        this.loadingSpinnerTarget.classList.add("hidden")
      }
    }
    if (this.hasSubmitTextTarget) {
      this.submitTextTarget.textContent = loading ? "Envoi en cours..." : "Envoyer ma demande"
    }
  }
}
